import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Audiobooks from "../pages/audiobooks/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/audiobooks",
    element: <Audiobooks />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
